<template>
    <TBotaoIcon class="mbutton" 
      :class="{ 'disabled': !canSearch }"
      border-color="#2650e7"
      background-color="#2650e7" 
      hover-color="#1b3ebf" 
      text-color="white">
        {{ text }}
    </TBotaoIcon>
</template>

<script>
import { TBotaoIcon } from "umaui";

export default {
  name: 'searchButton',
  props:["canSearch","text"],
  components:{
    TBotaoIcon
  }
}
</script>

<style scoped>
  .mbutton.disabled,
  .mbutton.disabled:hover {
    background-color: #ccc;
    border-color: #ccc;
  }

  .mbutton.mobile{
    display: none;
  }

  .mbutton{
    width: 100%;
    text-align: center;
  }

  




  

 
  @media only screen and (max-width: 767px) {
    .mbutton{
      display: flex !important;
      border-radius: 20px;
    }

    .mbutton i{
      display: none;
    }
    /*.mbutton{
      display: none !important;
    }
    .mbutton.mobile{
      display: flex !important;
      border-radius: 20px;
    }*/
  }

</style>

